'use strict'

import ApiClient from './ApiClient'

export default class FavoriteRepository {
  /**
   * 名刺人物をお気に入りに追加します。
   * @param {int} sid_assign
   * @returns {*}
   */
  favorite (sid_assign) {
    return ApiClient().post(`/favorited-bcards`, { sid_assign })
  }

  /**
   * 指定されたIDの名刺人物のお気に入りを解除します。
   * @param {string|int} person_id 人物ID
   * @returns {*}
   */
  unfavorite (person_id) {
    return ApiClient().delete(`/favorited-bcards/${person_id}`)
  }

  /**
   * 複数の名刺人物を一括でお気に入り状態に変更します。すべての名刺人物がすでにお気に入り済みの場合だったときは、お気に入り状態を解除します。
   * @param {array} sid_bcards 名刺IDの配列
   * @param {array} conds ID指定しない場合の検索条件
   * @returns {*}
   */
  bulk (sid_bcards, conds) {
    return ApiClient().put(`/favorited-bcards/bulk`, { sid_bcards, ...conds })
  }
}



// WEBPACK FOOTER //
// ./src/repositories/FavoriteRepository.js